import React from "react";
import TransactionTable from "./components/TransactionTable";
function CustomerTransactions() {
  return (
    <div>
      <TransactionTable />
    </div>
  );
}

export default CustomerTransactions;
